'use client';

import { getLeadBrowserContext } from 'libs/utilities/src/lib/leadBrowserContext';
import { useEffect } from 'react';

/** Exposes `getLeadBrowserContext` to the Act-On scripts in `public/js`, which cannot import it. */
export function LeadBrowserContextBridge() {
  useEffect(() => {
    window.getLeadBrowserContext = getLeadBrowserContext;
  }, []);
  return null;
}
